import React, { useState, useEffect } from 'react';
import { Button, Table, Modal, Form, Alert, Stack, Spinner } from 'react-bootstrap';
import { FaEdit, FaTrash, FaPlus } from 'react-icons/fa';
import { getBudgets, createBudget, updateBudget, deleteBudget } from '../Budgets/budgets.js';

export default function BudgetsManager({ jwt }) {
    const [budgets, setBudgets] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [editingBudget, setEditingBudget] = useState(null);
    const [budgetName, setBudgetName] = useState('');
    const [error, setError] = useState('');

    const loadBudgets = async () => {
        setLoading(true);
        try {
            const data = await getBudgets(jwt);
            setBudgets(data || []);
        } catch (err) {
            console.error(err);
            setError('Не удалось загрузить бюджеты');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadBudgets();
    }, [jwt]);

    const handleSaveBudget = async () => {
        if (!budgetName.trim()) {
            setError('Название не может быть пустым');
            return;
        }
        try {
            if (editingBudget) {
                await updateBudget(editingBudget.id, budgetName, jwt);
            } else {
                await createBudget(budgetName, jwt);
            }
            setShowModal(false);
            setEditingBudget(null);
            setBudgetName('');
            setError('');
            await loadBudgets();
        } catch (err) {
            setError('Ошибка сохранения');
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm('Удалить бюджет? Это также удалит все значения у продуктов.')) {
            try {
                await deleteBudget(id, jwt);
                await loadBudgets();
            } catch (err) {
                setError('Ошибка удаления');
            }
        }
    };

    if (loading) return <div className="text-center mt-5"><Spinner animation="border" /></div>;

    return (
        <div style={{ padding: '20px' }}>
            <Stack direction="horizontal" gap={3} className="mb-4">
                <h2>Управление бюджетами</h2>
                <Button variant="success" onClick={() => { setEditingBudget(null); setBudgetName(''); setShowModal(true); }}>
                    <FaPlus /> Добавить бюджет
                </Button>
            </Stack>
            {error && <Alert variant="danger" onClose={() => setError('')} dismissible>{error}</Alert>}
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>Название</th>
                        <th style={{ width: '150px' }}>Действия</th>
                    </tr>
                </thead>
                <tbody>
                    {budgets.map((budget, idx) => (
                        <tr key={budget.id}>
                            <td>{budget.name}</td>
                            <td>
                                <Button size="sm" variant="warning" className="me-2" onClick={() => {
                                    setEditingBudget(budget);
                                    setBudgetName(budget.name);
                                    setShowModal(true);
                                }}>
                                    <FaEdit />
                                </Button>
                                <Button size="sm" variant="danger" onClick={() => handleDelete(budget.id)}>
                                    <FaTrash />
                                </Button>
                            </td>
                        </tr>
                    ))}
                    {budgets.length === 0 && (
                        <tr><td colSpan="3" className="text-center">Нет бюджетов. Создайте первый.</td></tr>
                    )}
                </tbody>
            </Table>

            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{editingBudget ? 'Редактировать бюджет' : 'Новый бюджет'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group>
                        <Form.Label>Название</Form.Label>
                        <Form.Control type="text" value={budgetName} onChange={e => setBudgetName(e.target.value)} />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>Отмена</Button>
                    <Button variant="primary" onClick={handleSaveBudget}>Сохранить</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}